<script setup lang="ts">
  import { Route } from "@/constants/route"
  import { StepWizardReviewContent } from "@/types/StepWizard.ts"
  import { useRouter } from "vue-router"
  import Button from "@/components/ui/button/Button.vue"
  import { StepWizardProgressCard } from "@/components/ui/step-wizard"
  import StepWizardReview from "@/components/ui/step-wizard/StepWizardReview.vue"

  const router = useRouter()

  const onSubmit = () => {
    router.push(Route.innovationTariffConfirmation)
  }

  const reviewContent: StepWizardReviewContent[] = [
    {
      content: [
        {
          title: "Tariff",
          text: ["Innovation Tariff"],
        },
      ],
    },
    {
      content: [
        {
          title: "Payment type",
          text: ["Equal payments"],
        },
      ],
    },
    {
      content: [
        {
          title: "Payment method",
          text: ["Direct Debit"],
        },
      ],
    },
    {
      content: [
        {
          title: "Monthly payments",
          text: ["£100"],
        },
      ],
    },
  ]
</script>

<template>
  <form novalidate @submit.prevent="onSubmit">
    <StepWizardProgressCard title="Review information">
      <StepWizardReview :content-information="reviewContent" />
      <template #next_button>
        <Button variant="tonal" type="submit" size="md">Confirm</Button>
      </template>
    </StepWizardProgressCard>
  </form>
</template>
